import { render } from "./OverMij.vue?vue&type=template&id=515359b9&scoped=true"
import script from "./OverMij.vue?vue&type=script&lang=js"
export * from "./OverMij.vue?vue&type=script&lang=js"

import "./OverMij.vue?vue&type=style&index=0&id=515359b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515359b9"]])

export default __exports__